import { get, patch } from './apiClient';

export interface Notification {
  _id: string;
  type: string;
  title: string;
  message: string;
  link: string | null;
  metadata: Record<string, unknown>;
  readBy: string[];
  isRead: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationsResponse {
  notifications: Notification[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export async function fetchNotifications(page = 1, limit = 30): Promise<NotificationsResponse> {
  const res = await get<{ success: boolean; data: NotificationsResponse }>(
    `/notifications?page=${page}&limit=${limit}`
  );
  return res.data;
}

export async function fetchUnreadCount(): Promise<number> {
  const res = await get<{ success: boolean; data: { count: number } }>(
    '/notifications/unread-count'
  );
  return res.data.count;
}

export async function markNotificationAsRead(id: string): Promise<void> {
  await patch(`/notifications/${id}/read`, {});
}

export async function markAllNotificationsAsRead(): Promise<void> {
  await patch('/notifications/read-all', {});
}
